import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaSlider from './VaSlider.vue'

export const VaSlider = withConfigTransport(_VaSlider)
